var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FilterQuery, LoadableModel } from '@veeam/core';
import deepEqual from 'fast-deep-equal';
import { merge } from 'rxjs';
import { FiltersPersistLocalStorage } from "./FiltersPersistLocalStorage";
import { COLLECTION_MODEL_FILTER_TYPES } from "./types";
var CollectionModel = /** @class */ (function (_super) {
    __extends(CollectionModel, _super);
    function CollectionModel(idGetter, loader, initialValue) {
        var _this = this;
        var value = {};
        Object.assign(value, initialValue, {
            items: [],
            filters: new FilterQuery([]),
            selection: [],
            checked: [],
            expanded: [],
            pagination: null,
            sorting: []
        });
        _this = _super.call(this, loader, value) || this;
        _this.valueType = {};
        _this.loaderType = {};
        _this.getItemID = idGetter;
        _this.filtersPersistStorage = null;
        _this.waitForReadFilters = null;
        _this.isFiltersRead = false;
        _this.filtersPersistStorageNameSpace = '';
        _this.waitInitOperationStack = [];
        _this.buildDataIndex();
        return _this;
    }
    CollectionModel.prototype.withPagination = function (pagination) {
        this.update(function (prevValue) {
            prevValue.pagination = pagination;
        });
        return this;
    };
    CollectionModel.prototype.withSorting = function (sorting) {
        this.update(function (prevValue) {
            prevValue.sorting = [sorting];
        });
        return this;
    };
    CollectionModel.prototype.withFiltersFromArray = function (filters) {
        this.update(function (prevValue) {
            prevValue.filters = FilterQuery.fromArray(filters);
        });
        return this;
    };
    CollectionModel.prototype.withFiltersFromGroups = function (filterGroups) {
        this.update(function (prevValue) {
            prevValue.filters = FilterQuery.fromGroups(filterGroups);
        });
        return this;
    };
    CollectionModel.prototype.withFilters = function (filters) {
        this.update(function (prevValue) {
            prevValue.filters = filters;
        });
        return this;
    };
    CollectionModel.prototype.withAdditionalValues = function (additionalValues) {
        this.update(function (prevValue) {
            Object.entries(additionalValues).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                prevValue[key] = value;
            });
        });
        return this;
    };
    CollectionModel.prototype.getItemById = function (id) {
        var items = this.getValue().items;
        var idx = this.itemIndex[String(id)];
        if (typeof idx !== 'number') {
            return null;
        }
        return items[idx] || null;
    };
    CollectionModel.prototype.getSelectedItems = function () {
        var _this = this;
        var selection = this.getValue().selection;
        return selection.reduce(function (items, id) {
            var item = _this.getItemById(id);
            if (item !== null) {
                items.push(item);
            }
            return items;
        }, []);
    };
    CollectionModel.prototype.setFilter = function (filterIndex, filter) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.withInitUpdatePool(function () {
                    _this.update(function (prevValue) {
                        if (!filter) {
                            prevValue.filters = prevValue.filters.mapFilter(filterIndex, null);
                            return;
                        }
                        prevValue.filters = prevValue.filters.mapFilter(filterIndex, function (prevFilter) { return (__assign(__assign({}, prevFilter), filter)); });
                    });
                });
                return [2 /*return*/];
            });
        });
    };
    CollectionModel.prototype.actualizeSelection = function () {
        var _this = this;
        var currentPageIDs = this.getValue().items.reduce(function (acc, curr) {
            var id = _this.getItemID(curr);
            acc[String(id)] = true;
            return acc;
        }, {});
        this.update(function (prevValue) {
            prevValue.selection = prevValue.selection.filter(function (id) { return currentPageIDs[String(id)]; });
        });
    };
    CollectionModel.prototype.withSyncItemComparator = function (comparator) {
        var _this = this;
        var defaultIdComparator = function (prev, next) {
            return deepEqual(prev.map(function (i) { return _this.getItemID(i); }), next.map(function (i) { return _this.getItemID(i); }));
        };
        return this.withSyncComparator(function (prevValue, nextValue) {
            return (comparator || defaultIdComparator)(prevValue.items, nextValue.items);
        });
    };
    CollectionModel.prototype.withFiltersStorage = function (namespace, storage) {
        var _this = this;
        if (storage === void 0) { storage = new FiltersPersistLocalStorage(); }
        this.filtersPersistStorageNameSpace = namespace;
        this.filtersPersistStorage = storage;
        this.waitForReadFilters = this.readFilters().then(function () {
            _this.waitForReadFilters = null;
        });
        return this;
    };
    CollectionModel.prototype.load = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.waitForReadFilters) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.waitForReadFilters];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, _super.prototype.load.call(this, payload)];
                    case 3:
                        _a.sent();
                        this.actualizeSelection();
                        return [2 /*return*/];
                }
            });
        });
    };
    CollectionModel.prototype.sync = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.waitForReadFilters) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.waitForReadFilters];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, _super.prototype.sync.call(this, payload)];
                }
            });
        });
    };
    CollectionModel.prototype.destroy = function () {
        var _a;
        (_a = this.filterAndSortingSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        _super.prototype.destroy.call(this);
    };
    CollectionModel.prototype.setValue = function (value) {
        _super.prototype.setValue.call(this, value);
        this.buildDataIndex();
    };
    CollectionModel.prototype.update = function (updater) {
        _super.prototype.update.call(this, updater);
        this.buildDataIndex();
    };
    CollectionModel.prototype.isAllItemsSelected = function (filter) {
        var value = this.getValue();
        var selection = value.selection;
        if (!selection.length) {
            return false;
        }
        var items = value.items;
        var end = items.length;
        for (var i = 0; i < end; i++) {
            var item = items[i];
            var key = String(this.getItemID(item));
            if (filter && !filter(item, i)) {
                continue;
            }
            if (!this.selectionIndex[key]) {
                return false;
            }
        }
        return true;
    };
    CollectionModel.prototype.readFilters = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.filtersPersistStorage || this.isFiltersRead) {
                            this.initUpdatePoolRelease();
                            return [2 /*return*/];
                        }
                        this.isFiltersRead = true;
                        return [4 /*yield*/, this.filtersPersistStorage.read(this.filtersPersistStorageNameSpace)];
                    case 1:
                        data = _b.sent();
                        if (data) {
                            this.update(function (prev) {
                                prev.filters = prev.filters.fromArray(data.filters);
                                prev.sorting = data.sorting;
                            });
                        }
                        (_a = this.filterAndSortingSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
                        this.filterAndSortingSubscription = merge(this.fieldChanges('filters'), this.fieldChanges('sorting')).subscribe(function () {
                            _this.saveFilters();
                        });
                        this.initUpdatePoolRelease();
                        return [2 /*return*/];
                }
            });
        });
    };
    CollectionModel.prototype.saveFilters = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, (_a = this.filtersPersistStorage) === null || _a === void 0 ? void 0 : _a.save(this.filtersPersistStorageNameSpace, {
                        filters: this.getValue()
                            .filters.getFilterList()
                            .filter(function (item) {
                            return item.type !== COLLECTION_MODEL_FILTER_TYPES.search;
                        }),
                        sorting: this.getValue().sorting
                    })];
            });
        });
    };
    CollectionModel.prototype.buildDataIndex = function () {
        this.buildItemIndex();
        this.buildSelectionIndex();
    };
    CollectionModel.prototype.buildItemIndex = function () {
        this.itemIndex = {};
        var items = this.getValue().items;
        var end = items.length;
        for (var i = 0; i < end; i++) {
            var item = items[i];
            this.itemIndex[String(this.getItemID(item))] = i;
        }
    };
    CollectionModel.prototype.buildSelectionIndex = function () {
        this.selectionIndex = {};
        var items = this.getValue().selection;
        var end = items.length;
        for (var i = 0; i < end; i++) {
            var item = items[i];
            this.selectionIndex[String(item)] = true;
        }
    };
    CollectionModel.prototype.initUpdatePoolRelease = function () {
        this.waitInitOperationStack.forEach(function (cb) { return cb(); });
        this.waitInitOperationStack = [];
    };
    CollectionModel.prototype.withInitUpdatePool = function (operation) {
        if (this.waitForReadFilters) {
            this.waitInitOperationStack.push(operation);
            return;
        }
        operation();
    };
    return CollectionModel;
}(LoadableModel));
export { CollectionModel };
//# sourceMappingURL=CollectionModel.js.map